import { useTranslations } from 'next-intl'
import { ComponentProps } from 'react'

import { useSearchFilterStore } from '@/entities/map'
import { cn } from '@/shared/lib'
import { Chip, Icon } from '@/shared/ui'

type FilterMenuProps = Omit<ComponentProps<typeof Chip>, 'children'>

export const All = (props: FilterMenuProps) => {
  const t = useTranslations('map.filter')

  const count = useSearchFilterStore(state => state.count)
  const hasFilter = count > 0

  return (
    <Chip
      variant="outline"
      size="medium"
      shape="pill"
      selected={hasFilter}
      className="relative max-w-8"
      {...props}
    >
      <Icon name="filter" size={16} className="text-black" />
      <span className="sr-only">{t('all')}</span>
      {hasFilter && (
        <span
          className={cn(
            'block h-4 w-4 rounded-full bg-purple-500 text-[9px] leading-2.5 font-semibold tracking-[-0.1px] text-white',
            'flex items-center justify-center',
            'absolute top-0 -right-[7px]',
          )}
        >
          {count}
        </span>
      )}
    </Chip>
  )
}

export const Item = ({ children, ...restProps }: FilterMenuProps) => {
  return (
    <Chip
      variant="outline"
      size="medium"
      shape="pill"
      className="[&[data-state=open]_svg]:rotate-180"
      endIcon={
        <Icon
          name="arrow-bottom"
          className={cn('transition-transform duration-200')}
        />
      }
      {...restProps}
    >
      {children}
    </Chip>
  )
}
